import { useEffect, useState, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Camp } from '../types/database';
import { trackEvent } from '../lib/analytics';

interface CampMapProps {
  camps: Camp[];
  center: [number, number];
  zoom: number;
  onCampSelect: (camp: Camp) => void;
  onMapMove?: (center: [number, number]) => void;
  hoveredCampId?: string | null;
  userLocation?: [number, number] | null;
  radius?: number | null; // Radius in miles for visualization
}

export default function CampMap({ camps, center, zoom, onCampSelect, onMapMove, hoveredCampId, userLocation, radius }: CampMapProps) {
  const navigate = useNavigate();
  const [MapComponent, setMapComponent] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    // Dynamically import the map component only on the client side
    import('./MapComponent').then((module) => {
      setMapComponent(() => module.default);
    });
  }, []);

  if (!MapComponent) {
    return (
      <div className="h-full w-full flex items-center justify-center bg-gray-100 rounded-lg">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="h-full rounded-lg overflow-hidden shadow-md relative map-wrapper-branded">
      <MapComponent
        camps={camps}
        center={center}
        zoom={zoom}
        onCampSelect={onCampSelect}
        onMapMove={onMapMove}
        navigate={navigate}
        hoveredCampId={hoveredCampId}
        userLocation={userLocation}
        radius={radius}
      />
    </div>
  );
} 